import { alias, params, extend } from '@thd-nucleus/data-sources';

import {
  arrayOf as arrayOfType,
  number as numberType,
  shape as shapeType,
  string as stringType,
  bool as boolType
} from '@thd-nucleus/data-sources/react/dataModel/prop-types';

const Promotion = shapeType({
  experienceTag: stringType(),
  subExperienceTag: stringType(),
  anchorItemList: arrayOfType(stringType()),
  itemList: arrayOfType(stringType()),
  reward: shapeType({
    tiers: arrayOfType(shapeType({
      minPurchaseAmount: numberType({ float: true }),
      minPurchaseQuantity: numberType({ float: true }),
      rewardPercent: numberType({ float: true }),
      rewardAmountPerOrder: numberType({ float: true }),
      rewardAmountPerItem: numberType({ float: true }),
      rewardFixedPrice: numberType({ float: true })
    }))
  })
});

const Fulfillment = params({ storeId: stringType() }).shape({
  fulfillmentOptions: arrayOfType(shapeType({
    fulfillable: boolType(),
    type: stringType(),
    services: arrayOfType(shapeType({
      type: stringType(),
      locations: arrayOfType(shapeType({
        isAnchor: boolType(),
        locationId: stringType(),
        inventory: shapeType({
          isOutOfStock: boolType(),
          quantity: numberType()
        })
      }))
    }))
  }))
});

const Media = shapeType({
  image: shapeType({
    url: stringType()
  }).client(),
  images: arrayOfType(shapeType({
    url: stringType(),
    sizes: arrayOfType(stringType()),
    type: stringType(),
    subType: stringType()
  }))
});

export const dataModel = extend({
  clientOnlyProduct: alias('product').params({ itemId: stringType().isRequired() }).shape({
    dataSource: stringType(),
    itemId: stringType(),
    pricing: params({ storeId: stringType().isRequired() }).shape({
      alternate: shapeType({
        bulk: shapeType({
          value: numberType({ float: true })
        })
      }),
      value: numberType({ float: true }),
      promotion: Promotion,
      preferredPriceFlag: boolType(),
    }),
    fulfillment: Fulfillment,
    media: Media
  })
});
